(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klout-pdp"]) return;
  try {
    
(function(){
  function init(root){
    if(!root || root.__kpdp) return; root.__kpdp = true;
    var track=root.querySelector('#kpdp-galtrack'),dots=root.querySelectorAll('#kpdp-galdots span'),thumbs=root.querySelectorAll('#kpdp-thumbs img');
    if(track){track.addEventListener('scroll',function(){var i=Math.round(track.scrollLeft/track.clientWidth);dots.forEach(function(x,j){x.classList.toggle('act',j===i)});thumbs.forEach(function(x,j){x.classList.toggle('act',j===i)});},{passive:true});}
    thumbs.forEach(function(x){x.addEventListener('click',function(){var j=+x.dataset.i;track.scrollTo({left:track.clientWidth*j,behavior:'smooth'});});});
    root.querySelectorAll('.kpdp-tab').forEach(function(b){b.addEventListener('click',function(){root.querySelectorAll('.kpdp-tab').forEach(function(x){x.classList.remove('act')});root.querySelectorAll('.kpdp-pane').forEach(function(x){x.classList.remove('act')});b.classList.add('act');var p=root.querySelector('#'+b.dataset.t);if(p)p.classList.add('act');});});
    var pnow=root.querySelector('[data-price-now]'),pwas=root.querySelector('[data-price-was]'),psave=root.querySelector('[data-price-save]');
    root.querySelectorAll('.kpdp-szbtn').forEach(function(b){b.addEventListener('click',function(){
      root.querySelectorAll('.kpdp-szbtn').forEach(function(x){x.classList.remove('act')});b.classList.add('act');
      if(pnow)pnow.textContent=b.dataset.price;
      var hc=b.dataset.hasCompare==='1';
      if(pwas){pwas.textContent=b.dataset.compare;pwas.hidden=!hc;}
      if(psave){psave.textContent=b.dataset.save;psave.hidden=!hc;}
      var vid=b.dataset.vid;
      if(vid){try{var u=new URL(window.location);u.searchParams.set('variant',vid);window.history.replaceState({},'',u);}catch(e){}
        var sel=document.querySelector('select[name="id"],input[name="id"]');if(sel){sel.value=vid;sel.dispatchEvent(new Event('change',{bubbles:true}));}
        document.querySelectorAll('.kpdp-sticky [data-sprice]').forEach(function(s){s.textContent=b.dataset.price;});
      }
    });});
    document.addEventListener('click',function(e){var t=e.target.closest('[data-scroll-buy]');if(t){e.preventDefault();var buy=document.querySelector('#kpdp-buy')||document.querySelector('#kpdp-buy-top');if(buy)buy.scrollIntoView({behavior:'smooth',block:'center'});}});
    function playVid(el){if(el.classList.contains('playing'))return;var src=el.dataset.videoSrc,emb=el.dataset.videoEmbed;if(src){el.innerHTML='<video src="'+src+'" controls autoplay playsinline></video>';el.classList.add('playing');}else if(emb){var u=emb;if(/youtu/.test(emb)){var id=(emb.match(/(?:v=|youtu\.be\/|embed\/)([\w-]{6,})/)||[])[1];if(id)u='https://www.youtube.com/embed/'+id+'?autoplay=1';}else if(/vimeo/.test(emb)){var vid=(emb.match(/vimeo\.com\/(\d+)/)||[])[1];if(vid)u='https://player.vimeo.com/video/'+vid+'?autoplay=1';}el.innerHTML='<iframe src="'+u+'" allow="autoplay; fullscreen" allowfullscreen style="width:100%;height:100%;border:0"></iframe>';el.classList.add('playing');}}
    root.querySelectorAll('.kpdp-vid,.kpdp-authcard').forEach(function(el){if(el.dataset.videoSrc||el.dataset.videoEmbed){el.addEventListener('click',function(){playVid(el);});}});
  }
  function boot(){document.querySelectorAll('.kpdp').forEach(init);}
  if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();
})();
